<template>
  <donut-page-title
    title="Build Your Journey with AI"
    lucide-icon="Sparkles"
  />
  <div class="f-jc f-ac h-75vh">
    <component :is="currentComponent" />
  </div>
</template>

<script setup>
  import { computed, onBeforeMount, watch } from 'vue';
  import { useStore } from 'vuex';
  import useJourneyBuilderFormSubmission from 'composables/journey-builder/form-submission';

  const { commit, state } = useStore();
  const { pollForWorkflowProgress } = useJourneyBuilderFormSubmission('completed', (workflow) => `/onboarding/tags/${workflow.tag_id}?source=journey_builder`);

  const props = defineProps({
    workflow: { type: Object, required: true },
  });

  const currentComponent = computed(() => {
    const prefix = 'journey-builder-workflows-loading-journey-';
    const eventsRequiringInput = state.journeyBuilderWorkflow?.events_requiring_user_input;
    if (eventsRequiringInput?.channel_messaging?.length) {
      return `${prefix}-channel-messages`;
    } else if (eventsRequiringInput?.channel_inviting?.length) {
        return `${prefix}-channel-inviting`;
    }
      return `${prefix}-bullets`;
  });

  watch(currentComponent, (newValue, oldValue) => {
    if (newValue.endsWith('bullets')) {
      pollForWorkflowProgress(props.workflow.id);
    }
  });

  onBeforeMount(() => {
    commit('update', { key: 'journeyBuilderWorkflow', value: props.workflow }, { root: true });
    pollForWorkflowProgress(props.workflow.id);
  });
</script>
